<div class="popover-menu">
    <div class="menu-toggle" (click)="toggleMenu()">Toggle Menu</div>
    <ul *ngIf="menuState === 'open'">
        <li *ngFor="let item of menuItems" (click)="onItemClick(item)">
            {{ item.name }}
        </li>
    </ul>
</div>